<script lang="ts">
    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';

    export let isOpen;
    export let maxWidth;
    export let type;

    const toggleBodyOpenedModalClass = () => document.body.classList.toggle('modal-opened');

    onMount(() => {
        toggleBodyOpenedModalClass();
        return toggleBodyOpenedModalClass;
    });

    $: zIndex = type === 'DANGER' ? 'z-9999' : 'z-9000';
</script>

<div class="modal {zIndex}" class:is-active={isOpen} transition:fade|global>
    <div class="modal_backdrop" transition:fade|global />
    <div class="modal_content" style={maxWidth && `max-width: ${maxWidth}px;`}>
        <div>
            <slot />
        </div>
    </div>
</div>

<style lang="scss">
    .modal {
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        place-items: center;
        flex-wrap: nowrap;
        flex-shrink: 0;
        flex-grow: 0;
        width: 100%;
        height: 100%;

        &_backdrop {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
        }

        &_content {
            z-index: 1;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            place-items: center;
            flex-wrap: nowrap;
            flex-shrink: 0;
            flex-grow: 0;

            & > div {
                width: calc(100% - 20px);
            }
        }
    }

    :global {
        body.modal-opened {
            overflow: hidden;
        }
    }
</style>
